import Keycloak from 'keycloak-js';
import { getRuntimeConfig } from '../Lib/Config/RuntimeConfig';

export class KeyCloakService {
  private static _keycloak: Keycloak;

  static hasToken() {
    return !!sessionStorage.getItem("kc_token")
  }

  static isAnonymous() {
    return sessionStorage.getItem("kc_isAnonymous") === "true"
  }

  static isLogged() {
    return !this.isAnonymous();
  }

  static async login() {
    // Get runtime configuration
    const config = await getRuntimeConfig();

    this._keycloak = new Keycloak({
      url: config.NEXT_PUBLIC_KEYCLOAK_URL,
      realm: config.NEXT_PUBLIC_KEYCLOAK_REALM ?? '',
      clientId: config.NEXT_PUBLIC_KEYCLOAK_CLIENTID ?? '',
    } as unknown as any);

    this._keycloak.init({}).then((auth: boolean) => {
      if (!auth) {
        this._keycloak.login();
      } else {

      }
    })
  }
}